<template>
  <section class="section">
    <div class="columns">
      <div class="column is-6-desktop is-12-tablet is-12-mobile">
        <h1 class="title">Proceso</h1>
        <h2 class="subtitle">Seleccione el proceso en el que va a trabajar</h2>
      </div>
      <div class="column is-6-desktop is-12-tablet is-12-mobile" style="margin: auto">
        <div class="field has-addons" style='width: 100% !important;'>
          <div class="control" style='width: 100% !important;'>
            <input
                class="input is-large"
                v-model="cohorte.nombre"
                type="text"
                placeholder="Nombre del nuevo proceso"
                style='width: 100% !important;'
            />
          </div>
          <button class="button is-dark is-large" @click="saveCohorte">
        <span class="icon">
          <i class="material-icons">add_circle_outline</i>
        </span>
            <span>Crear</span>
          </button>
        </div>
      </div>
    </div>
    <hr/>
    <div class="columns">
      <div class="column">
        <p class="control has-icons-left has-icons-right">
          <input
              class="input is-medium is-focused"
              type="text"
              v-model="search"
              placeholder="Filtrar "
          />
          <span class="icon is-medium is-left">
          <i class="material-icons">search</i>
        </span>
        </p>
      </div>
    </div>
    <div class="is-block scroll-table scroll-light is-white">
      <table class="table is-fullwidth">
        <thead class="head-stick">
        <tr>
          <th></th>
          <th>Proceso</th>
          <th>Código</th>
          <th>Controles</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(k, v) in filteredItems" :key="v">
          <td>{{ v + 1 }}</td>
          <td>{{ k.nombre }}</td>
          <td>{{ k.codigo }}</td>
          <td>
            <div class="buttons">
              <button
                  class="button is-dark tooltip"
                  @click="seleccionar(k)"
                  data-tooltip="Seleccionar"
              >
              <span class="icon">
                <i class="material-icons">check</i>
              </span>
              </button>
              <button
                  class="button is-danger tooltip"
                  @click="eliminar(k)"
                  data-tooltip="Eliminar"
              >
              <span class="icon">
                <i class="material-icons">delete_forever</i>
              </span>
              </button>
              <button
                  class="button tooltip"
                  @click="activar(k)"
                  :class="active(k)"
                  data-tooltip="Activar"
              >
              <span class="icon">
                <i class="material-icons">toggle_on</i>
              </span>
              </button>
              <button
                  class="button is-link tooltip"
                  data-tooltip="Link Encuesta"
                  @click="linkacceso(k.codigo)"
              >
              <span class="icon">
                <i class="material-icons">share</i>
              </span>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import {mapState} from "vuex";

const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.nombre
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};

export default {
  data() {
    return {
      search: "",
      cohorte: {
        nombre: "",
      },
      listprocesos: [],
    };
  },
  computed: {
    ...mapState(["idtoken", "modalnotification"]),
    filteredItems: function () {
      return filterItems(this.search, this.listprocesos);
    },
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    linkacceso: function (d) {
      alert(
          `El link para el acceso a la encuesta es ${process.env.FRONT_URL}/accesocultura/${d}`
      );
    },
    async activar(proceso) {
      try {
        await apiServices.get(`/activecohortecultura/${proceso._id}`);
        this.traeprocesos();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrio un error activando el proceso. Intentelo más tarde",
          type: "is-danger",
          duration: 4000,
          position: "top-center",
        });
      }
    },
    active(proceso) {
      if (proceso.active) {
        return "is-dark";
      } else {
        return "is-light";
      }
    },
    async deleteProceso(_this, id) {
      try {
        const deleteAttached = this.$fire.deleteFolderAttached(id)
        if (!deleteAttached){
          await this.$store.dispatch("notify", {
            message: "Error al eliminar los anexos.",
            type: "is-danger",
            duration: 4000,
            position: "top-center",
          });
        }else {
          const result = await apiServices.delete(`/deletecohortecultura/${id}`);
          if (result.data) {
            if (result.data.message) {
              await this.$store.dispatch("notify", {
                message: result.data.message,
                type: "is-warning",
                duration: 4000,
                position: "top-center",
              });
            }
            await _this.traeprocesos();
          }
        }
      } catch (err) {
        console.log("ocurrio un error", err);
      }
    },
    eliminar(inf) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "¿Realmente desea eliminar el proceso?",
          clase: "is-white",
          data: inf._id,
        },
      });
    },
    seleccionar(d) {
      this.$emit("selproceso", d);
    },
    async saveCohorte() {
      try {
        if (!this.cohorte.nombre) {
          this.$store.dispatch("notify", {
            message: "La cohorte debe tener un nombre.",
            type: "is-warning",
            position: "top-center",
            duration: 5000,
          });
          return false;
        }
        await apiServices.post(`/cretecohortecultura`, this.cohorte);
        this.traeprocesos();
      } catch (err) {
        console.log(err);
      }
    },
    async traeprocesos() {
      this.listprocesos = [];
      try {
        const result = await apiServices.get(`/listcohortecultura`);
        if (result.data) {
          this.listprocesos = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteProceso(this, this.modalnotification.result.data);
      }
    },
    idtoken(nv,ov){
      if (nv){
        this.traeprocesos();
      }
    }
  },
  created() {
    if (this.idtoken){
      this.traeprocesos();
    }
  },
};
</script>
<style lang="scss">
.scroll-table {
  height: 306px;
  overflow-y: auto;
  overflow-x: hidden;
}

.head-stick th {
  background: white;
  position: sticky;
  top: -3px; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  z-index: 60 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Procesocultura.vue